module.exports = __webpack_public_path__ + "img/placeholder_newsfeed.6810fdd9.svg";